<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#kick"></use>
          </svg>

          <div class="text mt24">
			  <div class="text-size-l text-bold info-title">Пнуть всех</div>

              <p class="info-text">
                  СМС-уведомления будут отправлены<br>
				  всем пользователям, у которых есть<br>
				  непрочитанные правила.
              </p>
          </div>
          <div class="mt24">
              <submit-btn @click.native="kickUnReadAll" :type="kickUnReadAllBtnType">
                  <span class="i i-ok7 mr4" style="margin-top: -2px;" v-if="kickUnReadAllBtnType != 'load'"></span>Подтвердить
              </submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';

    export default {
        name: "KickUnReadAll",
        components: {
            SubmitBtn,
        },
        data: function(){
            return {
                kickUnReadAllBtnType: 'normal',
            }
        },
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.kickUnReadAll.name});
            },
            kickUnReadAll(){
                this.kickUnReadAllBtnType = 'load';
                this.$store.dispatch('rulesStaff/kickUnReadAll').then(()=>{
                    this.kickUnReadAllBtnType = 'normal';
                    this.close();
                });
            },
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
            }),

        }
    }
</script>

<style scoped>

</style>
